module.exports = __webpack_public_path__ + "img/banner-hen.b40f7f25.png";